// Value formatters for chart tooltips and KPI values. Series pass these through
// `valueFormatter` so no chart or tooltip does unit logic itself.
export const createMetricFormatters = (locale: string) => {
  const wholeNumberFormatter = new Intl.NumberFormat(locale, { maximumFractionDigits: 0 });
  const formatFixed = (value: number, fractionDigits: number) =>
    new Intl.NumberFormat(locale, { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits }).format(value);

  return {
    formatKg: (value: number): string => `${wholeNumberFormatter.format(Math.round(value))} kg`,
    formatWeightG: (value: number): string => `${wholeNumberFormatter.format(Math.round(value))} g`,
    formatCount: (value: number): string => wholeNumberFormatter.format(Math.round(value)),
    formatPercent: (value: number, fractionDigits = 1): string => `${formatFixed(value, fractionDigits)}%`,
    formatTemperature: (value: number): string => `${formatFixed(value, 1)}°C`,
    formatRatio: (value: number, fractionDigits = 2): string => formatFixed(value, fractionDigits),
    formatCurrencyPerKg: (value: number): string => `$${formatFixed(value, 2)}/kg`,
  };
};
